import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-close",
  templateUrl: "./med-icon-close.component.html",
})
export class MedIconCloseComponent extends SvgMixinComponent {}
